import { getAWSSignedURL } from '@app/api/file.api';
import avatarImg from '@app/assets/images/user-placeholder.png';
import { Avatar, AvatarProps, Col, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { H6 } from '../typography/H6/H6';
import * as S from './UserAvatar.styles';

interface UserAvatarProps extends AvatarProps {
  image: string | null | undefined;
  prefixText?: string | null;
  suffixText?: string | null;
  isPrefixTitle?: boolean;
  size?: number;
  noMargin?: boolean;
  tooltip?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = (props) => {
  const { image, prefixText, suffixText, isPrefixTitle, size, noMargin = false, tooltip = '' } = props;
  const { t } = useTranslation();

  const [imageUrl, setImageUrl] = useState<string>(avatarImg);

  useEffect(() => {
    async function fetchImage(image: string) {
      try {
        const signedUrl = await getAWSSignedURL(image);
        if (signedUrl) setImageUrl(signedUrl);
      } catch (error) {}
    }

    if (image) {
      fetchImage(image);
    }
  }, [image]);

  return (
    <S.Wrapper className={`avatar-wrapper ${noMargin ? 'no-margin' : ''}`}>
      {prefixText && (
        <Col>
          <H6 className={isPrefixTitle ? 'title' : 'avatar-prefix'}>{t(prefixText)}:</H6>
        </Col>
      )}
      <Col>
        <Tooltip title={tooltip || ''} placement="top">
          <Avatar src={imageUrl} alt="User" shape="circle" size={size || 40} />
        </Tooltip>
      </Col>
      {suffixText && (
        <Col>
          <H6 className="avatar-suffix">{suffixText}</H6>
        </Col>
      )}
    </S.Wrapper>
  );
};
